import React from 'react';
import { observer } from 'mobx-react';
import Modal from 'simple-react-modal';
import moment from 'moment';

import { CALENDAR_DISPLAY } from '../../constants/modals';

import { dismissModal } from './services';
import styles from './css/CalendarPromoModal.module.css';


const CalendarPromoModal = (props) => {
  const { showCalendarModal, closeCalendarModal, user } = props;
  const orderText = user?.features?.includes('CALENDAR_PREORDER') ? 'PRE ORDER' : 'ORDER';

  const handleDismissForever = () => {
    if (user.authenticated) {
      dismissModal({
        visible: false,
        count: 1,
        modalType: CALENDAR_DISPLAY,
      });
    } else {
      const tenYears = moment().
        add(10, 'years').
        toDate();
      setCookie(tenYears);
    }
    closeCalendarModal();
  };

  const handleClose = () => {
    if (user.authenticated) {
      dismissModal({
        visible: true,
        count: 1,
        modalType: CALENDAR_DISPLAY,
      });
    } else {
      const nextWeek = moment().
        add(7, 'days').
        toDate();
      setCookie(nextWeek);
    }
    closeCalendarModal();
  };

  const setCookie = (expiry) => {
    document.cookie = `CALENDAR_DISPLAY_2023=hidden; expires=${expiry}`;
  };

  return (
    <Modal
      closeOnOuterClick={true}
      containerClassName={styles.calendarModal}
      show={showCalendarModal}
      onClose={handleClose}
    >
      <div className={styles.calendarModalContent}>
        <div className={styles.calendarModalTextHolder}>
          <p className={styles.calendarModalAvailable}>Now available!</p>
          <h1 className={styles.calendarModalHeader}>2024</h1>
          <h4 className={styles.calendarModalSubHeader}>Naked News Calendar!</h4>
          <div className={styles.calendarModalFirstParagraph}>
            {' '}
            <ul>
              <li>The entire cast of Naked News in 12 months of stunning images.<br />
                Each month is a celebration of their incredible natural beauty.</li>
              <li><b>ADDED BONUS</b></li>
              <li>Also get 1 free month of your favorite anchors Fan Zone.
                This is your chance to connect with them on a more personal and intimate level.
              </li>
              <li><b>DON&apos;T MISS OUT</b></li>
            </ul>
          </div>
        </div>
      </div>
      <div className={styles.calendarModalFooter}>
        <a
          className="btn btn-red"
          href="https://shop.nakednews.com/index.php/product/2024-naked-news-calendar-12-x-12/"
          rel="noreferrer"
          target="_blank" onClick={closeCalendarModal}
        >
          {orderText} YOUR CALENDAR TODAY!
        </a>
        <div className={styles.calendarModalDismiss} onClick={handleDismissForever}>
          I don&apos;t want to see this message again
        </div>
      </div>
      <span className={styles.calendarModalCloseBtn} onClick={handleClose}>X</span>
    </Modal>
  );
};

export default observer(CalendarPromoModal);
